"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryContractDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const mui_inputs_image_firebase_1 = require("@dzambalaorg/mui-inputs-image-firebase");
const types_1 = require("@framework/types");
const popovers_1 = require("../../../../../../popovers");
const validation_1 = require("./validation");
const MysteryContractDialogForm = (props) => {
    const { selectedItem, open, mode, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, title, description, baseTokenURI, imageUrl, contractStatus, address, symbol, name, royalty, contractFeatures, } = selectedItem;
    const fixedValues = {
        id,
        title,
        address,
        description,
        contractStatus,
        imageUrl,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, testId: "MysteryContractEditForm", action: mode === "edit" ? ((0, jsx_runtime_1.jsx)(popovers_1.BlockchainInfoPopover, { name: name, symbol: symbol, address: address, baseTokenURI: baseTokenURI, contractFeatures: contractFeatures, ...(!contractFeatures.includes(types_1.ContractFeatures.SOULBOUND) && { royalty: `${royalty / 100}%` }) })) : null, filter: ({ title, description, imageUrl, contractStatus }) => ({
            title,
            description,
            imageUrl,
            contractStatus,
        }), ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title" }), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractStatus", options: types_1.ContractStatus, disabledOptions: [types_1.ContractStatus.NEW] }), (0, jsx_runtime_1.jsx)(mui_inputs_image_firebase_1.AvatarInput, { name: "imageUrl" })] }));
};
exports.MysteryContractDialogForm = MysteryContractDialogForm;
//# sourceMappingURL=index.js.map